import { render } from "./splashScreen.vue?vue&type=template&id=1018080f&scoped=true"
import script from "./splashScreen.vue?vue&type=script&lang=js"
export * from "./splashScreen.vue?vue&type=script&lang=js"

import "./splashScreen.vue?vue&type=style&index=0&id=1018080f&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1018080f"]])

export default __exports__